<template>
  <div>
    <v-layout justify-center wrap>
      <section
        id="headerSection"
        style="position: relative; width: 100vw; max-width: 2560px !important"
      >
        <v-img
          v-if="$vuetify.breakpoint.mdAndUp && siteType == 'General'"
          src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fwaves.svg?alt=media&token=62074b24-0ff9-46d7-b64b-2e06940eaf8d"
          class="lightBlueSwish"
        ></v-img>
        <v-img
          v-else-if="siteType == 'General'"
          src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fcommercial_home_swish_mobile.svg?alt=media&token=3b2f33af-7f3f-484a-b7b2-446487515b94"
          class="lightBlueSwishMobile"
        ></v-img>
        <v-layout row wrap v-if="siteType == 'General'">
          <v-flex xs12 lg6 class="headerLeft">
            <div class="headerLeftContainer">
              <!-- text -->
              <div class="generalHeaderText">
                <h1>Commercial</h1>
                <p>
                  Find out how you can make a difference <br />
                  through your supply chain.
                </p>
                <v-btn
                  color="info"
                  class="headerBtn text-capitalize pa-4 ml-0 mt-4"
                  @click="onExploreSuppliersClick('Commercial')"
                >
                  <!-- <v-icon class="mr-3">mdi-domain</v-icon> -->
                  <v-img
                    src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fcommercial%20icon-01%20(1).svg?alt=media&token=6444d739-dfea-499f-838a-421c6acbbb23"
                    alt="Commercial Icon"
                    class="btnImage"
                    contain
                    width="30"
                    height="30"
                  />
                  <p class="mb-0 ml-3">Explore Suppliers</p>
                </v-btn>
              </div>

              <!-- img -->
              <v-img
                :src="require('../assets/Headers/business-man_resized.png')"
                contain
                class="personImage"
              ></v-img>
            </div>
          </v-flex>
          <v-flex xs12 lg6 class="headerRight">
            <div class="headerLeftContainer">
              <!-- text -->
              <div class="generalHeaderText">
                <h1>Consumer</h1>
                <p>
                  Explore Upstream services and products <br />
                  for your home and lifestyle.
                </p>
                <v-btn
                  color="info"
                  class="headerBtn text-capitalize pa-4 ml-0 mt-4"
                  @click="onExploreSuppliersClick('Consumer')"
                >
                  <!-- <v-icon class="mr-3">mdi-home</v-icon> -->
                  <v-img
                    src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fhome%20icon-02%20(1).svg?alt=media&token=593eb756-9ea8-4824-81a9-0c5d6658612e"
                    alt="Consumer Icon"
                    class="btnImage"
                    contain
                    height="30"
                    width="30"
                  />

                  <p class="mb-0 ml-3">Explore Suppliers</p>
                </v-btn>
              </div>

              <!-- img -->
              <v-img
                v-if="$vuetify.breakpoint.mdAndUp"
                :src="require('../assets/Headers/mum-and-girl.png')"
                height="700"
                width="1000"
                contain
                style="top: 0; right: -165px; position: absolute"
              ></v-img>
              <!-- img -->
              <v-img
                v-else
                :src="require('../assets/Headers/mum-and-girl.png')"
                contain
                class="personImage"
              ></v-img>
            </div>
          </v-flex>
        </v-layout>
        <div
          v-if="siteType == 'Commercial'"
          class="headerContent"
          :class="{
            headerMobile: $vuetify.breakpoint.mdAndDown,
          }"
          style="background-color: #162c47"
        >
          <!-- text -->
          <v-img
            v-if="$vuetify.breakpoint.lgAndUp"
            src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FNO_Swish_commercial_home-19.jpg?alt=media&token=e3adbe13-0a4a-4da2-a6e2-4d92d407f9b5"
            contain
          ></v-img>
          <v-img
            v-if="$vuetify.breakpoint.mdAndDown"
            src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fhv9KgLuk.jpeg?alt=media&token=a047b6f2-2c5e-4d31-8ec3-ed38792a7e42"
            contain
          ></v-img>
          <div class="headerText light">
            <h1>
              Create social and <br />
              sustainable impact <br />
              in your supply chain
            </h1>
          </div>
        </div>
        <div
          v-if="siteType == 'Consumer'"
          class="headerContent"
          :class="{
            headerMobile: $vuetify.breakpoint.mdAndDown,
          }"
        >
          <!-- text -->
          <v-img
            v-if="$vuetify.breakpoint.lgAndUp"
            src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FNO_swish_consumer_home-20.jpg?alt=media&token=dd0e62eb-6847-4006-971f-936ec11a90af"
          ></v-img>
          <v-img
            v-if="$vuetify.breakpoint.mdAndDown"
            src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fu28qpUmc.jpeg?alt=media&token=2fbb4d70-455d-4581-8903-cb257da90884"
          ></v-img>
          <div class="headerText dark">
            <h1>
              Strengthen the <br />
              wellbeing of young <br />
              people by using <br />
              Upstream suppliers <br />
              at home
            </h1>
          </div>
        </div>
      </section>
      <!-- TODO: Latest Enquiry (Carparked) -->
      <!-- TODO: display overlay for explorer -->
      <section
        style="position: relative; min-width: 100vw; z-index: 10 !important"
      >
        <v-layout row wrap align-center class="impactToDate">
          <v-flex xs12>
            <h3 class="heading my-4">Our impact to date</h3>
          </v-flex>
          <v-flex xs12 class="pt-0">
            <v-layout row wrap class="statsContainer">
              <v-flex xm12 sm6 md4 style="text-align: center">
                <h3 class="counterTextHome">
                  ${{ contributionsCommaCurrent }}
                </h3>
                <h4 class="counterTextHome">
                  Upstream contributions generated so far
                </h4>
              </v-flex>
              <v-flex xm12 sm6 md4 style="text-align: center">
                <h3 class="counterTextHome">
                  {{ communityHourCalc | moneyWithComma }}
                </h3>
                <h4 class="counterTextHome">
                  Equivalent hours of generated community work
                </h4>
              </v-flex>
              <v-flex xs12 md4 style="text-align: center">
                <h3 class="counterTextHome">
                  {{ numberGoodCauses | moneyWithComma }}
                </h3>
                <h4 class="counterTextHome">Upstream Good Causes</h4>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- About section -->
<!--        <v-layout row wrap class="py-0">-->
<!--          <about style="top: 3px; left: -3px" />-->
<!--        </v-layout>-->
        <!-- Featured listings section -->
        <!-- <v-layout
          row
          wrap
          align-center
          style="padding-left: 15px; padding-right: 15px"
        >
          <v-flex v-if="fullWidthBanner != undefined" xs12>
            <a
              v-if="fullWidthBanner[0]"
              @click="
                $router.push(`/business/${fullWidthBanner[0].business_id}`)
              "
            >
              <v-img
                v-if="!$vuetify.breakpoint.xs"
                style="cursor: pointer; border-radius: 5px"
                :src="fullWidthBanner[0].imageUrl"
              />
              <v-img
                v-else
                style="cursor: pointer; border-radius: 5px"
                :src="fullWidthBanner[0].mobileImageUrl"
              />
            </a>
          </v-flex>
          <v-flex
            v-for="feature in featuredListings"
            :key="feature.imageUrl"
            xs12
            sm4
          >
            <v-card
              v-if="feature.frontPagePosition != 'Banner'"
              tile
              class="elevation-1"
              @click="$router.push(`/business/${feature.business_id}`)"
            >
              <v-img :src="feature.imageUrl" aspect-ratio="2" />
            </v-card>
          </v-flex>
        </v-layout> -->
        <section
          class="featuredListingsSection"
          style="max-width: 1920px !important; margin: auto"
        >
          <swiperCarousel
            :slides="1"
            swiperID="FeaturedListings"
            :options="filterFeatureListingsBySiteType"
          ></swiperCarousel>
        </section>
      </section>
      <div style="height: 1.5px; width: 100%; margin-top: 3rem; margin-bottom: 3rem;">
        <div style="background-color: rgb(167, 164, 164); height: 100%; width: 80%; margin-left: auto; margin-right: auto"></div>
      </div>
      <!-- Impact Buyers slider -->
      <section class="ibSection">
        <h1 style="margin-top: 0px !important;">Companies using Upstream in their supply chain</h1>
        <swiperCarousel
          :slides="3"
          :options="impactBusinesses"
        ></swiperCarousel>
      </section>
    </v-layout>

    <v-dialog v-model="feedBackBox" max-width="350px">
      <v-card>
        <v-card-text>
          <p v-if="$route.params.emailFeedbackType == 'no'">
            Thank you for your feedback. We aim to give great service and we
            will follow this up for you with the supplier.
          </p>
          <p v-if="$route.params.emailFeedbackType == 'yes'">
            Thank you for letting us know that
            <b style="font-size: 12pt">{{ $route.params.supplierName }}</b> has
            been in touch with you. We aim to provide our customers with great
            service. <br />
            <br />We are happy to help if you require further assistance.
            <br />Email
            <a href="mailto:admin@upstream.co.nz">admin@upstream.co.nz</a>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="
              $router.push('/');
              feedBackBox = false;
            "
            >Close</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import about from "@/components/core/About.vue";
import swiperCarousel from "@/components/swiper/swiperCarousel.vue";

export default {
  components: {
    about,
    swiperCarousel,
  },
  data: () => ({
    menuProps: {
      openOnClick: false,
    },
    communityHours: 0,
    items: [
      {
        src: "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F1_resized.jpg?alt=media&token=0f475253-a02b-4ae2-ac0c-e5d0761291b0",
      },
      {
        src: "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F2_resized.jpg?alt=media&token=f901d032-bd8a-4463-9678-f448419c3339",
      },
      {
        src: "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F3_resized.jpg?alt=media&token=f42656ea-0c3e-482d-b37d-6532c5d92548",
      },
      {
        src: "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F4_resized.jpg?alt=media&token=ab1040be-cb40-45a2-a165-867782b0ea61",
      },
      {
        src: "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F6_resized.jpg?alt=media&token=14050181-b066-4f91-90c3-57afa9cb2dd0",
      },
      {
        src: "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F7_resized.jpg?alt=media&token=7a372f29-a81c-4483-bb0d-b017fe3af8f8",
      },
    ],
    formData: {},
    feedBackBox: false,
  }),
  computed: {
    ...mapGetters({
      user: "user",
      services: "business/services",
      featuredListings: "featuredListings/listHomePage",
      fullWidthBanner: "featuredListings/fullWidthBanner",
      categories: "categories/list",
      categoriesByName: "categories/byName",
      contributions: "general/contributions",
      goodCauses: "goodCauses/approved",
      impactBusinesses: "impactBusinesses/list",
      siteType: "general/siteType",
    }),
    filterFeatureListingsBySiteType() {
      let filteredListings = this.featuredListings.filter((e) => {
        if (e.frontPagePosition != "Not On Frontpage") {
          if (this.siteType == "General") {
            return e;
          } else if (this.siteType == "Consumer") {
            if (e.isCommercial == "0") {
              return e;
            }
          } else if (this.siteType == "Commercial") {
            if (e.isCommercial == "1") {
              return e;
            }
          }
        }
      });
      filteredListings.sort((a, b) =>
        a.frontPagePosition > b.frontPagePosition
          ? 1
          : b.frontPagePosition > a.frontPagePosition
          ? -1
          : 0
      );
      return filteredListings;
    },
    communityHourCalc: function () {
      let hours = this.calculateCommunityHrs(this.contributions.current);
      if (hours > this.communityHours) {
        return hours;
      } else {
        return this.communityHours;
      }
    },
    contributionsCommaCurrent: function () {
      if (this.contributions.current != null) {
        return Math.round(parseFloat(this.contributions.current))
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    numberGoodCauses: function () {
      let count = 0;
      this.goodCauses.forEach((element) => {
        if (
          !element.name.includes("( Impact an Area )") &&
          !element.name.includes("( Impacts Overall )")
        ) {
          count += 1;
        }
      });
      return count;
    },
  },
  methods: {
    onExploreSuppliersClick(type) {
      this.$store.dispatch("general/changeType", type);
      this.$router.push("/searchResults");
    },
  },
  mounted() {
    this.$store.dispatch("featuredListings/loadAll");
    this.$store.dispatch("general/loadAll");
    if (this.$route.params.hasOwnProperty("emailFeedbackType")) {
      this.feedBackBox = true;
    }
  },
};
</script>

<style>
.application {
  background-color: white !important;
}

.browseBarWrap {
  position: relative;
  background: #4cc7e8;
  width: 100vw;
  top: 0px;
  height: 100px;
}

.browseBarContainer {
  position: relative;
  margin: auto;
  text-align: center;
  margin-top: 8px;
  /* max-width: 75%; */
}

.browseBarContainer h1 {
  font-weight: bold !important;
  font-family: Gotham !important;
  font-size: 3rem !important;
  color: white;
}

.searchOverlay {
  position: absolute;
  top: 0px;
  font-weight: bold;
  font-family: Gotham;
  font-size: 22pt;
  text-align: center;
  color: white;
  left: inherit;
  width: 100%;
  /*background: rgba(56, 240, 255, 0.65);*/
  padding: 15px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.headline {
  font-family: Gotham !important;
}

.fullHeight {
  height: 100%;
}

.lightBlueSwish {
  filter: invert(76%) sepia(76%) saturate(1663%) hue-rotate(160deg)
    brightness(96%) contrast(89%);
  -moz-transform: scale(-1, -1);
  -o-transform: scale(-1, -1);
  -webkit-transform: scale(-1, -1);
  transform: scale(-1, -1) rotate(10deg);
  position: absolute;
  width: 1500px;
  left: -70px;
  bottom: -150px;
}

.lightBlueSwishMobile {
  width: 960px;
  z-index: 1;
  position: absolute;
  top: 220px;
}

#headerSection button {
  font-weight: lighter;
  font-size: 20px !important;
}

#headerSection h1 {
  font-weight: bold !important;
  font-size: 3rem !important;
}

.generalHeaderText {
  position: absolute;
  top: 78px;
  left: 50px;
  z-index: 2;
}

.headerContent {
  min-height: 400px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
}

.headerContent .headerText {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 200px;
}

.headerMobile .headerText {
  right: unset;
  left: 50%;
  top: 22%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 100%;
}

.light {
  color: white;
}

.dark {
  color: #162c47;
}

.headerLeft {
  background-color: #162c47;
  color: white;
}

.headerLeftContainer {
  height: 500px;
  position: relative;
}

.headerRight {
  background-color: #ddf5fc;
  color: #162c47;
}

.headerLeft,
.headerRight {
  height: 100%;
}

.headerLeft .personImage {
  width: 1000px;
  height: 577px;
  top: -78px;
  right: -140px;
  position: absolute;
  z-index: 1;
}

.headerRight .personImage {
  width: 1000px;
  height: 577px;
  bottom: -100px;
  right: -250px;
  position: absolute;
  z-index: 1;
}

.ibSection {
  width: 90%;
  max-width: 1920px;
  margin: 0 0 5% 0;
}

.ibSection h1 {
  color: #4cc7e8;
  font-weight: bold !important;
  margin-bottom: 5%;
}

@media only screen and (max-width: 1263px) {
  .lightBlueSwish {
    bottom: 412px;
  }
}

@media only screen and (max-width: 1000px) {
  .counterTextHome {
    font-size: 20pt !important;
  }
  .headerLeft h1,
  .headerLeft p {
    z-index: 2;
  }
}

@media only screen and (max-width: 810px) {
  .lightBlueSwishMobile {
    width: 100%;
  }
  #headerSection .headerMobile .headerText h1 {
    font-size: 1.5rem !important;
  }
}

@media only screen and (max-width: 632px) {
  .browseBarContainer h1 {
    font-size: 2rem !important;
  }
  .headerLeft .personImage {
    height: 665px !important;
    width: 480px !important;
    top: -200px;
    right: -65px;
  }
  .headerRight .personImage {
    height: 305px !important;
    width: 480px !important;
    bottom: -50px;
    right: -115px;
  }
  .lightBlueSwishMobile {
    top: 175px;
  }
  .headerLeftContainer {
    height: 291px;
  }
  .headerLeft .generalHeaderText {
    top: 0;
    left: 0;
    padding: 6%;
  }
  .headerLeft .generalHeaderText p {
    font-size: 12px !important;
  }
  .headerLeft .generalHeaderText .headerBtn {
    height: 30px;
    width: 150px;
  }

  .headerLeft .generalHeaderText .headerBtn .btnImage {
    min-width: 30px !important;
    max-width: 30px !important;
  }
  .headerLeft .generalHeaderText .headerBtn p {
    font-size: 12px !important;
  }
  .headerRight .generalHeaderText {
    top: 0;
    left: 0;
    padding: 6%;
  }
  .headerRight .generalHeaderText p {
    font-size: 12px !important;
  }
  .headerRight .generalHeaderText .headerBtn {
    height: 30px;
    width: 150px;
  }

  .headerRight .generalHeaderText .headerBtn .btnImage {
    min-width: 30px !important;
    max-width: 30px !important;
  }
  .headerRight .generalHeaderText .headerBtn p {
    font-size: 12px !important;
  }
}

@media only screen and (max-width: 600px) {
  .categoryCardsHome {
    padding: 0 0 14px 0 !important;
  }
  .browseBarContainer h1 {
    font-size: 2rem !important;
  }
  .headerMobile.headerContent {
    height: auto;
  }
  #headerSection .headerMobile h1 {
    font-size: 2rem !important;
  }
}

@media only screen and (max-width: 377px) {
  #headerSection .headerMobile h1 {
    font-size: 2rem !important;
  }
}

@media only screen and (min-width: 600px) {
  .searchOverlay {
    font-size: 28pt;
    width: 600px;
    left: calc(50% - 300px);
  }
}

@media only screen and (min-width: 1904px) {
  .pageContent {
    max-width: 1200px;
  }
}

.display-3 {
  font-family: Gotham !important;
}
</style>

<style lang="scss">
.impactToDate {
  background: #4ac7e9;
  padding-left: 15px;
  padding-right: 15px;

  .heading {
    font-weight: 500 !important;
    color: white;
    text-align: center;
    margin-bottom: 0px !important;
  }

  .statsContainer {
    max-width: 1600px;
    margin: auto !important;
    color: #162c47;

    h3 {
      font-size: 3rem !important;
      color: #162c47;
      margin-bottom: 15px;

      @media screen and (max-width: 600px) {
        font-size: 2rem !important;
      }
    }

    h4 {
      font-family: Gotham !important;
      font-size: 1.3rem !important;
      color: white;
      margin: auto;
      max-width: 400px;
      top: -20px;
      position: relative;
    }
  }
}
</style>